import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CuttingPanel } from '../../models/cutting/public-api';

@Injectable()
export abstract class PanelListDataService {
  abstract downloadPanelsCsv(
    orderId: number,
    materialInMatBaseId: number,
    panels: CuttingPanel[],
    schemaId: number
  ): Observable<Blob>;
  abstract downloadPanelAttachment(
    orderId: number,
    materialInMatBaseId: number,
    attachmentName: string
  ): Observable<Blob>;
}
